import AxiosPermisos from "../../axiosPermisos";
import { path } from "./path";

async function getDiagnostcByUser(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getDiagnostcByUser}/${id}`,
    true,
    "v2",
    data,
    signal
  );
}

async function getEmployee(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getEmployee}/${id}`,
    true,
    "v1",
    data,
    signal
  );
}

async function getCities(data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getCities}`,
    true,
    "v1",
    data,
    signal
  );
}

async function getClaims(data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getClaims}`,
    true,
    "v2",
    data,
    signal
  );
}

async function getAllBodyParts(data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getAllBodyParts}`,
    true,
    "v2",
    data,
    signal
  );
}

async function saveHealthCondition(data) {
  return await AxiosPermisos.post(
    `${path.saveHealthCondition}`,
    true,
    data,
    "v2"
  );
}

async function saveFiles(id, data) {
  return await AxiosPermisos.postSendFile(
    `${path.saveFiles}/${id}/update-files`,
    true,
    data,
    "v2"
  );
}

async function saveFileAuthorization(data) {
  return await AxiosPermisos.postSendFile(
    `${path.saveFileAuthorization}`,
    true,
    data,
    "v2"
  );
}

async function saveMorbidity(data) {
  return await AxiosPermisos.post(
    `${path.saveMorbidity}`,
    true,
    data,
    "v2"
  );
}

async function saveAuthorization(data) {
  return await AxiosPermisos.post(
    `${path.saveAuthorization}`,
    true,
    data,
    "v2"
  );
}

async function verifyAuthorization(code, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.verifyAuthorization}/${code}/is-authorized`,
    true,
    "v2",
    data,
    signal
  );
}

async function getAllHealthCondition(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getAllHealthCondition}/${id}/list`,
    true,
    "v2",
    data,
    signal
  );
}

async function getAllMorbidity(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getAllMorbidity}/${id}/list`,
    true,
    "v2",
    data,
    signal
  );
}

async function detailHealthCondition(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.detailHealthCondition}/${id}`,
    true,
    "v2",
    data,
    signal
  );
}

async function getMorbidity(id, data = {}, signal) {
  return await AxiosPermisos.get(
    `${path.getMorbidity}/${id}`,
    true,
    "v2",
    data,
    signal
  );
}

function debounce(func, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    const context = this;
    timer = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
}

export {
  debounce,
  getDiagnostcByUser,
  getCities,
  getClaims,
  saveHealthCondition,
  getAllHealthCondition,
  detailHealthCondition,
  getEmployee,
  getAllBodyParts,
  saveFiles,
  saveMorbidity,
  saveAuthorization,
  verifyAuthorization,
  getMorbidity,
  getAllMorbidity,
  saveFileAuthorization,
};
